import { render, staticRenderFns } from "./domaine-joseph-drouhin.vue?vue&type=template&id=0d97bdd6&scoped=true"
import script from "./domaine-joseph-drouhin.vue?vue&type=script&lang=js"
export * from "./domaine-joseph-drouhin.vue?vue&type=script&lang=js"
import style0 from "./domaine-joseph-drouhin.vue?vue&type=style&index=0&id=0d97bdd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d97bdd6",
  null
  
)

export default component.exports